import React from 'react';
import { Code2, Facebook, Twitter, Instagram, Linkedin, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 pt-16 pb-8 border-t border-slate-900" data-id="element-97">
      <div className="container mx-auto px-4" data-id="element-98">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-99">
          {/* Company Info */}
          <div data-id="element-100">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-101">
              <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center" data-id="element-102">
                <Code2 className="text-white w-5 h-5" data-id="element-103" />
              </div>
              <span className="text-xl font-bold text-white" data-id="element-104">Hardy Blend</span>
            </a>
            <p className="text-sm leading-relaxed mb-6" data-id="element-105">
              Hardy Blend Web Design & Mobile App Development is your partner
              for digital innovation. We build scalable, robust, and beautiful
              digital solutions.
            </p>
            <div className="flex gap-4" data-id="element-106">
              <a href="#" className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all" data-id="element-107">
                <Facebook className="w-4 h-4" data-id="element-108" />
              </a>
              <a href="#" className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all" data-id="element-109">
                <Twitter className="w-4 h-4" data-id="element-110" />
              </a>
              <a href="#" className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all" data-id="element-111">
                <Instagram className="w-4 h-4" data-id="element-112" />
              </a>
              <a href="#" className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all" data-id="element-113">
                <Linkedin className="w-4 h-4" data-id="element-114" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-115">
            <h3 className="text-white font-bold mb-6" data-id="element-116">Quick Links</h3>
            <ul className="space-y-3" data-id="element-117">
              <li data-id="element-118">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-119">
                  Home
                </a>
              </li>
              <li data-id="element-120">
                <a href="#about" className="hover:text-red-500 transition-colors" data-id="element-121">
                  About Us
                </a>
              </li>
              <li data-id="element-122">
                <a href="#services" className="hover:text-red-500 transition-colors" data-id="element-123">
                  Services
                </a>
              </li>
              <li data-id="element-124">
                <a href="#portfolio" className="hover:text-red-500 transition-colors" data-id="element-125">
                  Portfolio
                </a>
              </li>
              <li data-id="element-126">
                <a href="#contact-form" className="hover:text-red-500 transition-colors" data-id="element-127">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-128">
            <h3 className="text-white font-bold mb-6" data-id="element-129">Services</h3>
            <ul className="space-y-3" data-id="element-130">
              <li data-id="element-131">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-132">
                  Web Development
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-134">
                  Mobile App Dev
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-136">
                  UI/UX Design
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-138">
                  E-commerce
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-140">
                  SEO Optimization
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-141">
            <h3 className="text-white font-bold mb-6" data-id="element-142">Contact Us</h3>
            <ul className="space-y-4" data-id="element-143">
              <li className="flex items-start gap-3" data-id="element-144">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-145" />
                <span data-id="element-146">17 Belvedere Rd, London N9 9YT, United Kingdom</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-147">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-148" />
                <a href="mailto:info@hardyblend.com" className="hover:text-white transition-colors" data-id="element-149">
                  info@hardyblend.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-900 pt-8 text-center text-sm" data-id="element-150">
          <p data-id="element-151">
            &copy; {new Date().getFullYear()} Hardy Blend Web Design & Mobile
            App Development. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}